jQuery( document ).ready(function() {
    bodyScrolled();
	navigation();
    popups(); 
    sliders();
    accordion();
    loginRegisterHandler();
    nominate();
});

jQuery( document ).on('gform_post_render', function(){
    nominate();
});

function inViewport(element) {
    let bounding = element.getBoundingClientRect();
    if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    ) {
        return true;
    } else {
        return false;
    }
}

function bodyScrolled() {
    let scrollPosition = window.scrollY;

    window.addEventListener('scroll', function() {
        scrollPosition = window.scrollY;

        if (scrollPosition >= 30) {
            document.body.classList.add('body-scrolled');
        } else {
            document.body.classList.remove('body-scrolled');
        }
    });
}